import type { AnyRouter } from "@tanstack/react-router";

/**
 * The launch splash (index.html, `src/splash/runtime.ts`) leaves once the first screen has drawn: the session is
 * known and the page under it is painted (its data may still be on the way, behind its placeholders). The splash
 * plays its own exit; when its player didn't run (a blocked inline script), the element is simply faded here.
 */
export function endSplashOnFirstScreen(router: AnyRouter): void {
  if (!document.getElementById("splash")) return;
  let ended = false;
  const end = () => {
    if (ended) return;
    ended = true;
    off();
    offRendered();
    // two frames: the screen React just committed has been painted before the splash starts to go
    requestAnimationFrame(() => requestAnimationFrame(endSplash));
  };
  const off = router.subscribe("onResolved", end);
  const offRendered = router.subscribe("onRendered", end);
}

export function endSplash(): void {
  if (window.__adeaSplash) {
    window.__adeaSplash.done();
    return;
  }
  const splash = document.getElementById("splash");
  if (!splash) return;
  splash.classList.add("out");
  window.setTimeout(() => splash.remove(), 400);
}

declare global {
  interface Window {
    __adeaSplash?: { done(): void };
  }
}
